import React from 'react';
import { useIntl } from 'react-intl';

const SyncedCollectionsListHeader = () => {
  const intl = useIntl();

  return (
    <tr>
      <th className="synced-collection-thumbnail" colSpan={2}>
        {intl.formatMessage({ defaultMessage: 'Collection' })}
      </th>
      <th>
        {' '}
      </th>
    </tr>
  );
};

export default SyncedCollectionsListHeader;
